import type { Command } from 'commander';
import { getConfigPath } from '../../lib/config-store';

export function registerConfigPath(parent: Command): void {
	parent
		.command('path')
		.description('Print the path to the config file (regardless of whether it exists)')
		.action(() => {
			process.stdout.write(getConfigPath() + '\n');
		});
}
